import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getUfs } from "../../services/apiUf";
import { postCidade } from "../../services/apiCidade";
import { erroToastify } from "../../shared/validacaoToastify";
import SelectGenerico from "../../components/selectGenerico/selectGenerico";
import InputGenerico from "../../components/inputGenerico/inputGenerico";
import { CamposPadroes } from "../../shared/CamposPadroes";
import { ToastContainer } from "react-toastify";
import "./cidade.css";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";

function IncluirCidade() {
  const [formValues, setFormValues] = useState({
    nomeCidade: "",
    cdUfSelecionada: "",
  });
  const [validacaoAtiva, setValidacaoAtiva] = useState<any>(false);
  const [ufs, setUfs] = useState<
    { nmSigla: string; cdUf: number; nmUf: string }[]
  >([]);
  const navigate = useNavigate();
  const selectRef = useRef<HTMLSelectElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    fetchUfs();
  }, []);

  useEffect(() => {
    if (validacaoAtiva && !formValues.cdUfSelecionada && selectRef.current) {
      selectRef.current.focus();
    } else if (validacaoAtiva && !formValues.nomeCidade && inputRef.current) {
      inputRef.current.focus();
    }
  }, [validacaoAtiva, formValues.cdUfSelecionada, formValues.nomeCidade]);

  const fetchUfs = async () => {
    try {
      const response = await getUfs("1");
      setUfs(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFieldChange = (name: string, value: string | number) => {
    setFormValues({ ...formValues, [name]: value });
    setValidacaoAtiva(false);
  };

  const handleConfirmar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const dataPresente = new Date();
    const envioDeDados = {
      nmCidade: formValues.nomeCidade,
      cdUf: formValues.cdUfSelecionada ? formValues.cdUfSelecionada : 0,
      ...CamposPadroes.toObjeto(
        1,
        1,
        dataPresente.toISOString(),
        dataPresente.toISOString(),
        true
      ),
    };

    try {
      const response = await postCidade({
        ...envioDeDados,
      });
      const successMessage = "A cidade foi incluída com sucesso!";
      navigate(
        `/milshop/cidade/consultar?successMessage=${encodeURIComponent(
          successMessage
        )}`
      );
    } catch (error: any) {
      if (error.response.data) {
        erroToastify(error.response.data);
        setValidacaoAtiva(true);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Incluir cidade</title>
      </Helmet>
      <div className="container mt-5">
        <div className="row justify-content-center ">
          <div className="col-md-6 bg-light rounded shadow p-4">
            <form className="mb-3" onSubmit={handleConfirmar}>
              <SelectGenerico
                opcoes={ufs.map((uf) => ({
                  valor: uf.cdUf,
                  rotulo: `(${uf.nmSigla}) ${uf.nmUf}`,
                }))}
                valorSelecionado={formValues.cdUfSelecionada}
                onChange={(value: string | number) =>
                  handleFieldChange("cdUfSelecionada", value)
                }
                label="Estado"
                mensagemError="Não há Estados a serem listados"
                opcaoPadrao="Selecione o Estado..."
                classe={`selectUf form-select mb-3  ${
                  !formValues.cdUfSelecionada && validacaoAtiva
                    ? "select-invalid"
                    : ""
                }`}
                classPadrao="corOption"
                validacaoAtiva={validacaoAtiva}
                ref={selectRef}
              />

              <InputGenerico
                name="nomeCidade"
                value={formValues.nomeCidade}
                onChange={(event: {
                  target: { name: string; value: string | number };
                }) => handleFieldChange(event.target.name, event.target.value)}
                label="Nome da Cidade"
                placeholder="Digite aqui..."
                className={`form-control ${
                  !(formValues.nomeCidade.length > 2) && validacaoAtiva
                    ? "input-invalid"
                    : ""
                }`}
                validacaoAtiva={validacaoAtiva}
                ref={inputRef}
                type="text"
              />
              <div className="d-flex mt-4">
                <a
                  className="btn btn-outline-danger me-2 btn-sm"
                  href="/milshop/cidade/consultar"
                  role="button"
                  style={{ width: "100px" }}
                >
                  Cancelar
                </a>
                <button
                  type="submit"
                  className="btn btn-outline-primary btn-sm"
                  style={{ width: "100px" }}
                >
                  Incluir
                </button>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
}

export default IncluirCidade;
